import { BADGE_LEVELS } from "@/lib/badges";
import { Star, Lock, CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";

export function BadgeShelf({ points = 0, testId = "badge-shelf" }) {
  return (
    <div data-testid={testId} className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
      {BADGE_LEVELS.map((lv, i) => {
        const unlocked = points >= lv.min;
        const isCurrent = points >= lv.min && (i === BADGE_LEVELS.length - 1 || points < BADGE_LEVELS[i + 1].min);
        return (
          <motion.div
            key={lv.level}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04 }}
            className={`relative rounded-2xl border p-3 text-center overflow-hidden ${
              isCurrent ? "border-sky-300 bg-sky-50 shadow-md" : unlocked ? "border-slate-200 bg-white" : "border-dashed border-slate-200 bg-slate-50"
            }`}
          >
            <div
              className={`mx-auto w-10 h-10 rounded-full grid place-items-center mb-2 ${unlocked ? "text-white" : "text-slate-300 bg-slate-100"}`}
              style={unlocked ? { background: lv.color } : {}}
            >
              {unlocked ? <Star className="w-5 h-5" fill="currentColor" /> : <Lock className="w-4 h-4" />}
            </div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-slate-400">Lv {lv.level}</div>
            <div className="text-xs font-semibold text-slate-800 leading-tight mt-1 min-h-[32px]">{lv.name}</div>
            {isCurrent && (
              <div className="mt-1 text-[10px] text-sky-700 font-bold flex items-center justify-center gap-1">
                <CheckCircle2 className="w-3 h-3" /> CURRENT
              </div>
            )}
          </motion.div>
        );
      })}
    </div>
  );
}
